import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { setPlaybackPosition } from '../utils/persistPlaybackPosition'
import { actionNames } from '../shared/actions.playback'
import { usePlaybackMetrics } from '../../firebase/hooks/useVideoPlayback'

// TODO: this is all business logic that could and should live outside of react
const usePlaybackMetricsUpdated = (photoId) => {
  const playbackMetrics = usePlaybackMetrics()
  const dispatch = useDispatch()

  useEffect(() => {
    if (playbackMetrics === null || !photoId) {
      return
    }

    setPlaybackPosition(photoId, playbackMetrics.position)

    dispatch({
      type: actionNames.VIDEO_PLAYBACK_METRICS_UPDATED,
      metrics: playbackMetrics,
    })
  }, [playbackMetrics, photoId, dispatch])
}

export default usePlaybackMetricsUpdated
